import { render, staticRenderFns } from "./html5_layout.vue?vue&type=template&id=0acd69a2&"
import script from "./html5_layout.vue?vue&type=script&lang=js&"
export * from "./html5_layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports